import { Switchboard } from "../../../events";
import { ToolbarButton, ToolbarButtonGroup } from "./ToolbarButton";
export class InteractionButton extends ToolbarButton {
    constructor(icon, description, id, title = '', buttonGroup = ToolbarButtonGroup.None) {
        super(icon, description, id, title, buttonGroup);
        this.title = title;
        this.buttonGroup = buttonGroup;
        this.interaction = '';
        this.interaction_emitter = Switchboard.get_emitter("INTERACTION");
        this.interaction_receiver = Switchboard.get_receiver("INTERACTION");
        this.buttonGroup = buttonGroup;
        this.interaction_receiver.on("changed", (i_name) => {
            if (i_name === this.interaction) {
                this.ui.addClass("highlighted");
            }
            else {
                if (this.buttonGroup == ToolbarButtonGroup.Group && i_name === '') {
                    return;
                }
                else
                    this.ui.removeClass("highlighted");
            }
        });
    }
    set_interaction(interaction_name) {
        this.interaction = interaction_name;
        return this;
    }
    _action() {
        this.interaction_emitter.emit('i_req_revert', this.interaction);
    }
}
